import React, { useState } from 'react';
import { Button } from '@progress/kendo-react-buttons';

interface ChatImageGridProps {
    imageUrls: string[];
}

export const ChatImageGrid: React.FC<ChatImageGridProps> = ({ imageUrls }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const imagesPerRow = 4;
    const showExpandButton = imageUrls.length > 5;

    const displayedImages = showExpandButton && !isExpanded
        ? imageUrls.slice(0, imagesPerRow)
        : imageUrls;

    if (!imageUrls || imageUrls.length === 0) {
        return null;
    }

    return (
        <div className="chat-image-grid-container">
            <div className="chat-image-grid">
                {displayedImages.map((url, index) => (
                    <div key={index} className="chat-image-wrapper">
                        <img
                            src={url}
                            alt={`Answer image ${index + 1}`}
                            className="chat-image"
                            loading="lazy"
                        />
                    </div>
                ))}
            </div>
            {showExpandButton && (
                <div className="chat-image-expand-button-container">
                    <Button
                        rounded="full"
                        className="chat-image-expand-button"
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        {isExpanded ? 'Show Less' : `Load ${imageUrls.length - imagesPerRow} more images`}
                    </Button>
                </div>
            )}
        </div>
    );
};
